export const DATES_CONFIGURATIONS = {
    LAST_MONTH: 'last_month',
    PREVIOUS_MONTH: 'previous_month',
    THIS_YEAR: 'this_year',
    ANY: 'any',
    CUSTOM_DATE: 'custom_date'
};
